/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FinancingLoanType, PAGE } from '@/constants/common';
import {
  DEFAULT_HDB_LOAN_DETAILS_AGE_65,
  MEDIUM_TERM_INTEREST_RATE,
  PropertyType,
} from '@/constants/hdb-resale/msr';
import { FormTypes } from '.';
import * as DefaultValue from '@/config/base-config.json';

export const initialState = {
  formField: {
    profiles: [
      {
        name: 'Profile A',
        age: DefaultValue.age,
        availableCash: 0,
        availableCPFOA: 0,
        monthlyFixedIncome: DefaultValue.monthlyFixedIncome,
        monthlyVariableIncome: 0,
        monthlyCarLoanInstalment: 0,
        monthlyOtherDebt: 0,
      },
    ],
    propertyType: PropertyType.HDB,
    loanType: FinancingLoanType.sixtyFiveYearLoan,
    loanTenure: DEFAULT_HDB_LOAN_DETAILS_AGE_65.LOAN_TENURE_MAX,
    mediumTermInterestRate: MEDIUM_TERM_INTEREST_RATE.DEFAULT,
    loanToValue: DEFAULT_HDB_LOAN_DETAILS_AGE_65.LOAN_TO_VALUE_MAX,
  },
  loading: true,
  from: '' as PAGE | '',
};

export const msrSlice = createSlice({
  name: 'msr',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: () => {},
});

export const { updateDataForm, updateFrom, reset } = msrSlice.actions;

export default msrSlice.reducer;
